import { useAuth0 } from '@auth0/auth0-react';

import {
  AUTH0_USER_PERMISSIONS_KEY,
  Auth0User,
} from '~/lib/constants/permissions.constants';

const useHasAuth0Permission = (permission: string): boolean => {
  const { user } = useAuth0<Auth0User>();
  return user?.[AUTH0_USER_PERMISSIONS_KEY]?.includes(permission) ?? false;
};

export default useHasAuth0Permission;
